import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetAccountPaymentMethods {
	response: Api.Operations['getAccountPaymentMethods']['responses']['200']['content']['application/json']
}

export const getAccountPaymentMethods = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetAccountPaymentMethods>(
		{
			method: 'get',
			url: '/account/payment_methods',
			...overideConfig,
		},
		axiosInstance,
	)
